import { Box, Container, Grid, Typography } from "@mui/material";

function ExtraSection() {
  return (
    <Container sx={{ py: 8 }}>
      <Grid container spacing={4} alignItems="center">
        {/* النص شمال */}
        <Grid item xs={12} md={6} sx={{ order: { xs: 2, md: 1 } }}>
          <Typography variant="h4" sx={{ fontWeight: 700, mb: 3 }}>
            DEAR RESPECTED READERS
          </Typography>

          <Typography variant="body1" sx={{ lineHeight: 2, mb: 2 }}>
            It is with absolute pride and great pleasure, that I offer you a
            glimpse of the history and upcoming potential of Alsegaey
            Agricultural Group. Everything that has been achieved, throughout
            the years since our early inception as a family business in 1940,
            was created with passion, integrity, sheer dedication and
            commitment to quality. We start a new era of business, based on our
            reputable and established heritage as a new starting point. We are
            elevating to higher levels of potential, promise and empowerment.
          </Typography>

          {/* ضيف باقي الرسالة هنا كفقرات إضافية */}

          <Typography variant="h6" sx={{ fontWeight: 700, mt: 3 }}>
            Dr. Sherif Alsegaey
          </Typography>
        </Grid>

        {/* الصورة يمين */}
        <Grid item xs={12} md={6} sx={{ order: { xs: 1, md: 2 } }}>
          <Box
            component="img"
            src="/upload/about-extra.jpg"
            alt="Dr. Sherif Alsegaey"
            sx={{
              width: "100%",
              minHeight: { md: "450px" },
              borderRadius: "10px",
              objectFit: "cover",
            }}
          />
        </Grid>
      </Grid>
    </Container>
  );
}

export default ExtraSection;